module.exports = __webpack_public_path__ + "img/new5.ce493b5a.png";